import React, { createContext, useContext, useState } from "react";

export const PermissionContext = createContext<any>(null);

export const PermissionProvider = ({ children }: { children: React.ReactNode }) => {
  const [permissionsMap, setPermissionsMap] = useState({}); // { route: ['view', 'edit'] }

  const setPermissionsFromMenu = (menuList: any[]) => {
    const permissionObj: Record<string, string[]> = {};

    menuList.forEach((menu) => {
      if (menu.menu_route && menu.permissions) {
        permissionObj[menu.menu_route] = menu.permissions.split(",");
      }
      menu.submenus?.forEach((submenu: any) => {
        if (submenu.route && submenu.permissions) {
          permissionObj[submenu.route] = submenu.permissions.split(",");
        }
      });
    });

    setPermissionsMap(permissionObj);
  };

  return (
    <PermissionContext.Provider value={{ permissionsMap, setPermissionsFromMenu }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);
